import script from "./EmailVerifyView.vue?vue&type=script&setup=true&lang=ts"
export * from "./EmailVerifyView.vue?vue&type=script&setup=true&lang=ts"

import "./EmailVerifyView.vue?vue&type=style&index=0&id=77b2c172&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-77b2c172"]])

export default __exports__